import "./StyledInput.scss";

import React from "react";

// base component
interface StyledInputBaseProps<T> {
  label?: string | React.ReactNode;
  value: T;
  setValue: (value: T) => void;
  type: string;
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "ghost";
  style?: React.CSSProperties;
  htmlFor?: string;
  width?: string | number;
}

export const StyledInputBase: React.FC<StyledInputBaseProps<any>> = ({
  label,
  children,
  className,
  variant = "default",
  style,
  htmlFor,
  width,
}) => {
  return (
    <div
      className={`styledInput ${variant} ${className || ""}`.trim()}
      // Width defaults to 100% (see StyledInput.scss) so inputs fill their
      // container. Only apply an inline width when the caller passes one
      // explicitly — an inline style would otherwise always beat the CSS default
      // and force callers into `!important` overrides.
      style={{ ...style, ...(width !== undefined ? { width } : {}) }}
    >
      {label && <label htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
};
